var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full p-5 scrolling-touch overflow-y-scroll"},[_c('MDArea',{staticClass:" max-w-2xl",attrs:{"md":require('raw-loader!./Overview.md').default}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }